import { useState, useEffect } from 'react';

export const useCart = () => {
  const [cart, setCart] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false);

  // Load cart from localStorage on mount
  useEffect(() => {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      try {
        setCart(JSON.parse(savedCart));
      } catch (error) {
        console.error('Error loading cart:', error);
        setCart([]);
      }
    }
  }, []);

  // Save cart to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  // Add item to cart
  const addToCart = (product) => {
    setCart(prevCart => {
      // Use cartId if available, otherwise use regular id
      const itemId = product.cartId || product.id;
      
      // Check if item already exists
      const existingIndex = prevCart.findIndex(item => {
        const existingId = item.cartId || item.id;
        return existingId === itemId;
      });

      if (existingIndex > -1) {
        // Item exists, increase quantity
        const newCart = [...prevCart];
        newCart[existingIndex].quantity += 1;
        return newCart;
      } else {
        // New item, add to cart
        return [...prevCart, { 
          ...product, 
          quantity: 1,
          cartId: itemId // Ensure cartId is set
        }];
      }
    });
    setIsCartOpen(true);
  };

  // Update quantity - FIXED VERSION
  const updateQuantity = (itemId, change) => {
    setCart(prevCart => {
      // Find the item
      const item = prevCart.find(item => {
        const existingId = item.cartId || item.id;
        return existingId === itemId;
      });

      if (!item) {
        console.warn('Item not found:', itemId);
        return prevCart;
      }

      const newQuantity = item.quantity + change;

      // If quantity is 0 or negative (remove item)
      if (newQuantity <= 0) {
        console.log('Removing item:', itemId);
        return prevCart.filter(item => {
          const existingId = item.cartId || item.id;
          return existingId !== itemId;
        });
      }

      // Update quantity
      return prevCart.map(item => {
        const existingId = item.cartId || item.id;
        if (existingId === itemId) {
          return { ...item, quantity: newQuantity };
        }
        return item;
      });
    });
  };

  // Remove item completely
  const removeItem = (itemId) => {
    setCart(prevCart => {
      console.log('Removing item:', itemId);
      return prevCart.filter(item => {
        const existingId = item.cartId || item.id;
        return existingId !== itemId;
      });
    });
  };

  // Clear cart
  const clearCart = () => {
    setCart([]);
  };

  return {
    cart,
    isCartOpen,
    setIsCartOpen,
    addToCart,
    updateQuantity,
    removeItem,
    clearCart
  };
};